import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, CircularProgress, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { useDispatch, useSelector } from 'react-redux';
import useCallOnce from '../../../hooks/useCallOnce';
// import { connectGmail, gmailCallback } from '../../../redux/actions/emailActions';
import { showSuccess, showError } from '../../../Components/reuse/Toast';
import { validateToken } from '../../../redux/actions/validateAction';
import gmailIcon from '../../../images/gmailIcon.png';
import { getUserById } from '../../../redux/actions/userActions';
import { Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon, ContentCopy as ContentCopyIcon, CheckCircle as CheckCircleIcon, Key as KeyIcon, Person as PersonIcon } from '@mui/icons-material';

const GmailIntegration = ({ selectedUserId, selectedUser }) => {
  const dispatch = useDispatch();
  const { gmailConnecting, gmailAuthUrl, gmailConnected, loading, emailData } = useSelector((state) => state.email);
  const { byId: userById } = useSelector((state) => state.users);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);
  const [showClientId, setShowClientId] = useState(false);
  const [showSenderEmail, setShowSenderEmail] = useState(false);
  const userLoading = Boolean(userById?.loading);
  
  // Check if Outlook is connected
  const outlookConnected = !!(emailData && emailData.outlook && (emailData.outlook.clientId || emailData.outlook.senderEmail));

  // useCallOnce('integration/gmail/connect', () => {
  //   dispatch(connectGmail()).catch(() => {});
  // });

  // useCallOnce('integration/gmail/callback', () => {
  //   const params = new URLSearchParams(window.location.search);
  //   const code = params.get('code');
  //   const state = params.get('state');
  //   if (code && state) {
  //     dispatch(gmailCallback({ state, code }))
  //       .then((res) => {
  //         if (res?.success && res?.message) {
  //           showSuccess(res.message);
  //           dispatch(validateToken());
  //           const newUrl = window.location.pathname + (window.location.hash || '');
  //           window.history.replaceState({}, document.title, newUrl);
  //         }
  //       })
  //       .catch(() => {});
  //   }
  // }, [dispatch]);

  // Parent Integration fetches user; avoid duplicate calls here

  const fallbackSelectedPayload = userById?.data?.data || userById?.data;
  const fallbackSelected = fallbackSelectedPayload?.user || fallbackSelectedPayload;
  const gmailFromUser = (selectedUser || fallbackSelected)?.gmail;
  const isGmailConnected = gmailConnected || !!(gmailFromUser && (gmailFromUser.clientId || gmailFromUser.senderEmail));

  const handleOpenGmail = () => {
    if (gmailConnected) return;
    
    // Check if Outlook is already connected
    if (outlookConnected) {
      showError('Remove Outlook to connect Gmail integration');
      return;
    }
    
    if (gmailAuthUrl) {
      window.open(gmailAuthUrl, '_self', 'noopener,noreferrer');
    }
  };

  return (
    <></>
    // <Box>
    //   <Card
    //     elevation={2}
    //     sx={{
    //       borderRadius: 2,
    //       bgcolor: '#ffffff',
    //       border: '1px solid #e5e7eb',
    //       height: '100%',
    //       minHeight: 350,
    //       cursor: isGmailConnected ? 'default' : 'pointer',
    //       '&:hover': !isGmailConnected ? { boxShadow: 4, borderColor: '#6b7280' } : {},
    //       transition: 'all 0.2s ease-in-out',
    //     }}
    //     onClick={!isGmailConnected ? handleOpenGmail : undefined}
    //   >
    //     <CardContent sx={{ p: 4, textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
    //       <Box>
    //         <Box sx={{ width: 64, height: 64, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', mx: 'auto', mb: 3, border: gmailConnected ? '2px solid #bbf7d0' : 'none' }}>
    //           {/* {(gmailConnecting || loading) ? (
    //             <CircularProgress size={28} />
    //           ) : (
    //             <img src={gmailIcon} alt="Gmail" style={{ width: 64, height: 64 }} />
    //           )} */}
    //           <img src={gmailIcon} alt="Gmail" style={{ width: 64}} />
    //         </Box>
    //         <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: gmailConnected ? '#16a34a' : '#111827' }}>
    //           Gmail
    //         </Typography>
    //       </Box>

    //       <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
    //         {userLoading ? (
    //           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>
    //             <CircularProgress size={22} />
    //           </Box>
    //         ) : isGmailConnected ? (
    //           <>
    //             <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2, bgcolor: '#f0fdf4', borderRadius: 2, border: '2px solid #bbf7d0' }}>
    //               <Typography variant="body2" sx={{ color: '#15803d', fontWeight: 600, fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
    //                 Connected
    //               </Typography>
    //             </Box>
    //             <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
    //               <Button variant="text" size="small" onClick={() => setDetailsModalOpen(true)} sx={{ color: '#6b7280', '&:hover': { backgroundColor: '#f3f4f6' } }}>
    //                 View Connection Details
    //               </Button>
    //             </Box>
    //           </>
    //         ) : (
    //           <>
    //             <Typography variant="body2" sx={{ mb: 2, color: '#6b7280' }}>
    //               Connect your Gmail account to send automated emails and notifications.
    //             </Typography>
    //             <Typography variant="body2" sx={{ color: '#6b7280' }}>
    //               {(gmailConnecting || loading) ? 'Preparing Google OAuth...' : 'Click to configure Gmail integration settings'}
    //             </Typography>
    //           </>
    //         )}
    //       </Box>
    //     </CardContent>
    //   </Card>

    //   {/* View Details Dialog */}
    //   <Dialog open={detailsModalOpen} onClose={() => setDetailsModalOpen(false)} maxWidth="sm" fullWidth>
    //     <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 2, borderBottom: '1px solid #e5e7eb', pb: 2, mb: 0 }}>
    //       <Box sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#16a34a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    //         <CheckCircleIcon sx={{ fontSize: 20, color: '#ffffff' }} />
    //       </Box>
    //       <Typography variant="h6" sx={{ fontWeight: 600 }}>
    //         Gmail Connection Details
    //       </Typography>
    //     </DialogTitle>

    //     <DialogContent sx={{ pt: 3, pb: 2 }}>
    //       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
    //         <TextField
    //           fullWidth
    //           label="Client ID"
    //           type={showClientId ? 'text' : 'password'}
    //           value={gmailFromUser?.clientId || ''}
    //           InputProps={{
    //             startAdornment: <KeyIcon sx={{ mr: 1, color: 'text.secondary' }} />,
    //             endAdornment: (
    //               <Box sx={{ display: 'flex', alignItems: 'center' }}>
    //                 <IconButton onClick={() => setShowClientId(!showClientId)} edge="end" size="small">
    //                   {showClientId ? <VisibilityOffIcon /> : <VisibilityIcon />}
    //                 </IconButton>
    //                 <IconButton onClick={() => navigator.clipboard.writeText(gmailFromUser?.clientId || '')} edge="end" size="small" sx={{ ml: 0.5 }}>
    //                   <ContentCopyIcon />
    //                 </IconButton>
    //               </Box>
    //             ),
    //           }}
    //           sx={{ '& .MuiInputBase-input': { color: '#6b7280' } }}
    //         />

    //         <TextField
    //           fullWidth
    //           label="Sender Email"
    //           type={showSenderEmail ? 'text' : 'password'}
    //           value={gmailFromUser?.senderEmail || ''}
    //           InputProps={{
    //             startAdornment: <PersonIcon sx={{ mr: 1, color: 'text.secondary' }} />,
    //             endAdornment: (
    //               <Box sx={{ display: 'flex', alignItems: 'center' }}>
    //                 <IconButton onClick={() => setShowSenderEmail(!showSenderEmail)} edge="end" size="small">
    //                   {showSenderEmail ? <VisibilityOffIcon /> : <VisibilityIcon />}
    //                 </IconButton>
    //                 <IconButton onClick={() => navigator.clipboard.writeText(gmailFromUser?.senderEmail || '')} edge="end" size="small" sx={{ ml: 0.5 }}>
    //                   <ContentCopyIcon />
    //                 </IconButton>
    //               </Box>
    //             ),
    //           }}
    //           sx={{ '& .MuiInputBase-input': { color: '#6b7280' } }}
    //         />
    //       </Box>
    //     </DialogContent>

    //     <DialogActions sx={{ p: 3, borderTop: '1px solid #e5e7eb', mt: 0 }}>
    //       <Button onClick={() => setDetailsModalOpen(false)} variant="contained">
    //         Close
    //       </Button>
    //     </DialogActions>
    //   </Dialog>
    // </Box>
  );
};

export default GmailIntegration;

